<template>
  <div>
    <base-header class="pb-6 bg-light">
      <b-row align-v="center" class="py-4">
        <b-col cols="12" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">eSIM Carrier Admin</h6>
        </b-col>
        <b-col cols="12" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
      <div v-if="noAccess">
        <b-card>
          <b-card-header>
            <p class="h2 mb-2">
              <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
              >&nbsp;Restricted
            </p>
          </b-card-header>
          <b-card-body>Access is Restricted</b-card-body>
        </b-card>
      </div>
      <div v-else>
        <!-- Name Table for Carriers Card -->
        <b-card no-body class="mb-0 border-non-radius">
          <b-card-header header-tag="header" class="p-0" role="tab">
            <base-button block type="primary" title="Search"
                         class="border-non-radius text-left d-flex justify-content-between">
              <div>Name</div>
              <base-button @click="reloadButtonClick()" type="warning" class="vertical-dot-button">
                <i class="fa fa-recycle"></i>
              </base-button>
            </base-button>
          </b-card-header>
          <b-card-body>
            <span>
              This page creates a new carrier profile for esim. The fields on this page may or may not
              be required depending on the sim scan. All EF values have the option of a defaultValue.
              While working you can choose to display as HEX or ASCII. The Field to the right will
              always display the readable text.
              <br>
              Please select a NEW or EXISTING Profile Type.
            </span>
          </b-card-body>
        </b-card>
        <b-card v-if="profileTypeLoading" id="lists_carrier_card">
          <b-row class="text-md-center">
            <b-col md="12">
              <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
            </b-col>
          </b-row>
        </b-card>
        <template v-else>
          <!-- START: NEW_CARRIER -->
          <b-card no-body class="mb-0 border-non-radius" id="new_carrier_card">
            <b-card-header header-tag="header" class="p-0 mb-0" role="tab">
              <base-button
                  block
                  v-b-toggle.accordion-2
                  type="info"
                  size="md"
                  title="Search"
                  v-on:click="defaultProfileTypeClick = !defaultProfileTypeClick"
                  class="border-non-radius text-dark text-left">
                <i class="fas  mr-1" v-bind:class="defaultProfileTypeClick ? 'fa-angle-down' : ' fa-angle-right'"></i>
                + New profileType
              </base-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion2" role="tabpanel">
              <b-card-body>
                <base-button type="primary" size="sm" class="text-white w-100 text-left">
                  General
                </base-button>
                <validation-observer ref="newCarrier" v-slot="{ handleSubmit }">
                  <b-form @submit.stop.prevent="handleSubmit(saveNewCarrier)">
                    <b-row class="mt-3">
                      <b-col md="8" lg="9">
                        <b-row class="mt-2">
                          <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                            <label for="parent" class="font-weight-900 mt-2">Clone From</label>
                          </b-col>
                          <b-col md="8" lg="8">
                            <validation-provider
                                name="parent"
                                :rules="{required: false,}"
                                v-slot="validationContext">
                              <b-form-group id="parent" class="mb-0">
                                <b-form-select
                                    id="parent"
                                    size="sm"
                                    v-model="defaultProfile.parent"
                                    v-on:change="getEFVariables"
                                    :options="profileTypeList"
                                ></b-form-select>
                                <b-form-invalid-feedback id="parent">{{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                            <label for="profileType" class="font-weight-900 mt-2">Profile Type</label>
                          </b-col>
                          <b-col md="8" lg="8">
                            <validation-provider
                                name="profileType"
                                :rules="{ required: true, regex: /^([A-Za-z0-9._]+)$/  }"
                                v-slot="validationContext">
                              <b-form-group id="profileType" class="mb-0">
                                <b-form-input
                                    id="profileType"
                                    name="profileType"
                                    size="sm"
                                    v-model="defaultProfile.profileType"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="profileType">
                                </b-form-input>
                                <b-form-invalid-feedback id="profileType">{{
                                    validationContext.errors[0]
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </b-row>

                        <b-row class="mt-2">
                          <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                            <label for="profileName" class="font-weight-900 mt-2">Profile Description</label>
                          </b-col>
                          <b-col md="8" lg="8">
                            <validation-provider
                                name="profileName"
                                :rules="{ required: true, regex: /^([A-Za-z0-9._ ]+)$/  }"
                                v-slot="validationContext">
                              <b-form-group id="profileName" class="mb-0">
                                <b-form-input
                                    id="profileName"
                                    name="profileName"
                                    size="sm"
                                    v-model="defaultProfile.profileName"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="profileName"
                                >
                                </b-form-input>
                                <b-form-invalid-feedback id="profileName">{{
                                    validationContext.errors[0]
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                            <label for="iccid" class="font-weight-900 mt-2">First ICCID</label>
                          </b-col>
                          <b-col md="8" lg="8">
                            <validation-provider
                                name="iccid"
                                :rules="{ required: true, regex: /^([0-9]+)$/, min: 18, max: 20 }"
                                v-slot="validationContext">
                              <b-form-group id="iccid" class="mb-0">
                                <b-form-input
                                    id="iccid"
                                    name="iccid"
                                    size="sm"
                                    v-model="defaultProfile.iccid"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="iccid">
                                </b-form-input>
                                <b-form-invalid-feedback id="profileName">{{
                                    validationContext.errors[0]
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                            <label for="serverProviderName" class="font-weight-900 mt-2">Service Provider Name</label>
                          </b-col>
                          <b-col md="8" lg="8">
                            <validation-provider
                                name="serverProviderName"
                                :rules="{ required: true, regex: /^([A-Za-z0-9._ ]+)$/  }"
                                v-slot="validationContext">
                              <b-form-group id="serverProviderName" class="mb-0">
                                <b-form-input
                                    id="serverProviderName"
                                    name="serverProviderName"
                                    size="sm"
                                    v-model="defaultProfile.serviceProviderName"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="serverProviderName">
                                </b-form-input>
                                <b-form-invalid-feedback id="profileName">{{
                                    validationContext.errors[0]
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                            <label for="mccMnc" class="font-weight-900 mt-2">mccMnc</label>
                          </b-col>
                          <b-col md="8" lg="8">
                            <validation-provider
                                name="mccMnc"
                                :rules="{ required: true, regex: /^([0-9]+)$/, length: 6  }"
                                v-slot="validationContext">
                              <b-form-group id="mccMnc" class="mb-0">
                                <b-form-input
                                    id="mccMnc"
                                    name="mccMnc"
                                    size="sm"
                                    v-model="defaultProfile.mccMnc"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="mccMnc">
                                </b-form-input>
                                <b-form-invalid-feedback id="profileName">{{
                                    validationContext.errors[0]
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                            <label for="gid1" class="font-weight-900 mt-2">Gid 1</label>
                          </b-col>
                          <b-col md="8" lg="8">
                            <validation-provider
                                name="gid1"
                                :rules="{ required: true }"
                                v-slot="validationContext">
                              <b-form-group id="gid1" class="mb-0">
                                <b-form-input
                                    id="gid1"
                                    name="gid1"
                                    size="sm"
                                    v-model="defaultProfile.gid1"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="gid1">
                                </b-form-input>
                                <b-form-invalid-feedback id="profileName">{{
                                    validationContext.errors[0]
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </b-row>
                        <b-row class="mt-2">
                          <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                            <label for="gid2" class="font-weight-900 mt-2">Gid 2</label>
                          </b-col>
                          <b-col md="8" lg="8">
                            <validation-provider
                                name="gid2"
                                :rules="{ required: true }"
                                v-slot="validationContext">
                              <b-form-group id="gid2" class="mb-0">
                                <b-form-input
                                    id="gid2"
                                    name="gid2"
                                    size="sm"
                                    v-model="defaultProfile.gid2"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="gid2">
                                </b-form-input>
                                <b-form-invalid-feedback id="profileName">{{
                                    validationContext.errors[0]
                                  }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                            </validation-provider>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="4" lg="3" class="text-center">
                        <base-button
                            type="primary"
                            size="sm"
                            title="Save"
                            native-type="submit"
                            class="mt-3 mt-md-2 mr-0 w-100">
                          Save Profile
                        </base-button>
                        <br>
                        <base-button
                            class=" mt-3 w-100"
                            size="sm"
                            type="success"
                            title="Publish Carrier Profile"
                            v-on:click="pushCarrierTemplate(defaultProfile.profileType)"
                            :disabled="!publishReady"
                        >
                          Publish to TruPhone
                        </base-button>
                        <!-- <div class="text-left text-black card-background"
                        v-model="statusText">
                        </div> -->
                      </b-col>
                    </b-row>

                    <b-row class="mt-3">
                      <table class="table eSimVariableTable ml-3 mr-3" id="myTable" v-if="templateVariables.length > 0">
                        <thead>
                        <th scope="col-2" class="name">
                          <span class="text-white">Name</span>
                        </th>
                        <th scope="col-6" class="ef"><span class="text-white">EF Variables</span></th>
                        <th scope="col-2" class="action"><span class="text-white">Action</span></th>
                        </thead>
                      </table>
                      <b-col md="12" lg="12" v-for="(val, index) in templateVariables" :key="index">
                        <div class="input-group esim-create-profile mb-1">
                          <b-input-group :prepend="val.name" id="carrier-profile-prepend">
                            <resizable-textarea ref="resize">
                              <b-form-textarea
                                  id="EF_ASEP"
                                  type="text"
                                  rows="1"
                                  ref="textarea"
                                  v-model="val.defaultValue"
                                  :maxlength="val.length"
                                  wrap="soft"
                              ></b-form-textarea>
                            </resizable-textarea>
                            <span class="group-append-button">
												<b-input-group-append is-text>
													<b-form-checkbox
                              value="ascii"
                              class="ascii-preview"
                              unchecked-value="hex"
                              v-on:change="convertCode(val.defaultValue, val.name,  $event)">
                          Preview</b-form-checkbox>
                          >
												</b-input-group-append>
<!--												<b-input-group-append is-text>-->
<!--													<b-form-checkbox-->
<!--                              v-model="val.sensitive"-->
<!--                              value="true"-->
<!--                              unchecked-value="false"-->
<!--                              disabled-->
<!--                          >Encrypted</b-form-checkbox-->
<!--                          >-->
<!--												</b-input-group-append>-->
											</span>
                          </b-input-group>

                        </div>
                      </b-col>
                      <b-col md="6" lg="6"></b-col>
                    </b-row>

                  </b-form>
                </validation-observer>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!-- END: NEW_CARRIER -->

          <!-- START: EXISTING_CARRIERS -->
          <b-card
              no-body
              class="mb-0 border-non-radius carrier-page-exist"
              v-for="(profileType, index) in profileTypes"
              :key="profileType.name">
            <!-- EXISTING_CARRIERS: {{ carrier.display_name }} -->
            <b-card-header header-tag="header" class="p-0 d-flex align-items-center justify-content-between mb-0"
                           role="tab">
              <base-button v-b-toggle="'accordion-3'+index" type="light" block
                        class="border-non-radius text-dark text-left d-flex justify-content-between">
                <div class="w-100"
                     v-on:click="profileType.dropdown = !profileType.dropdown; getExistingProfileType(profileType.profileType, profileType.dropdown)">
                  <span v-if="!profileType.disabled" class="dynamic">
                    <i class="fas mr-1 fa-angle-down"></i>
                    <i class="fas mr-1 fa-angle-right ml-0"></i>
                  </span>
                  {{ profileType.profileType }}
                </div>
                <!--                <b-button class="vertical-dot-button" variant="primary" :id="profileType.profileType+'popover'">-->
                <!--                  <b-icon icon="three-dots-vertical" class="font-16"></b-icon>-->
                <!--                </b-button>-->
              </base-button>
              <!--              <b-popover :target="profileType.profileType+'popover'" triggers="hover" placement="topleft">-->
              <!--                <b-row>-->
              <!--                  <base-button-->
              <!--                      type="link">-->
              <!--                    {{ !profileType.disabled ? "Disable" : "Enable" }}-->
              <!--                  </base-button>-->
              <!--                </b-row>-->
              <!--                <b-row v-if="profileType.can_remove">-->
              <!--                  <base-button-->
              <!--                      type="link">-->
              <!--                    Remove-->
              <!--                  </base-button>-->
              <!--                </b-row>-->
              <!--              </b-popover>-->
            </b-card-header>

            <b-collapse :id="'accordion-3'+index" accordion="my-accordion3" role="tabpanel">
              <b-card v-if="existingProfileLoading" id="lists_carrier_card">
                <b-row class="text-md-center">
                  <b-col md="12">
                    <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
                  </b-col>
                </b-row>
              </b-card>
              <template v-else>
                <b-card-body>
                  <base-button type="primary" size="sm" class="text-white w-100 text-left">
                    General
                  </base-button>
                  <validation-observer ref="existCarrier" v-slot="{ handleSubmit }">
                    <b-form @submit.stop.prevent="handleSubmit(saveCarrierTemplate())">
                      <b-row class="mt-3">
                        <b-col md="8" lg="9">

                          <b-row class="mt-2" v-if="!selectedProfile.profileType">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="profileType" class="font-weight-900 mt-2">Clone From</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <validation-provider
                                  name="parent"
                                  :rules="{ required: false,  }"
                                  v-slot="validationContext"
                              >
                                <b-form-group id="parent" class="mb-0">
                                  <b-form-select
                                      id="parent"
                                      size="sm"
                                      v-model="selectedProfile.parent"
                                      v-on:change="getExistingEFVariable"
                                      :options="profileTypeList"
                                  ></b-form-select>
                                  <b-form-invalid-feedback id="parent">{{
                                      validationContext.errors[0]
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>

                          <b-row class="mt-2">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="profileType" class="font-weight-900 mt-2">Profile Type</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <validation-provider
                                  name="profileType"
                                  :rules="{ required: true, regex: /^([A-Za-z0-9._]+)$/  }"
                                  v-slot="validationContext"
                              >
                                <b-form-group id="profileType" class="mb-0">
                                  <b-form-input
                                      id="profileType"
                                      name="profileType"
                                      size="sm"
                                      v-model="selectedProfile.profileType"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="profileType"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback id="profileType">{{
                                      validationContext.errors[0]
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>

                          <b-row class="mt-2">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="profileType" class="font-weight-900 mt-2">ProfileTypeId</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <b-form-input
                                  disabled
                                  id="profileTypeId"
                                  name="profileTypeId"
                                  size="sm"
                                  v-model="selectedProfile.profileTypeId"
                                  aria-describedby="profileTypeId"
                              >
                              </b-form-input>
                            </b-col>
                          </b-row>

                          <b-row class="mt-2">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="profileName" class="font-weight-900 mt-2">Profile Description</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <validation-provider
                                  name="profileName"
                                  :rules="{ required: true, regex: /^([A-Za-z0-9._ ]+)$/  }"
                                  v-slot="validationContext"
                              >
                                <b-form-group id="profileName" class="mb-0">
                                  <b-form-input
                                      id="profileName"
                                      name="profileName"
                                      size="sm"
                                      v-model="selectedProfile.profileName"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="profileName"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback id="profileName">{{
                                      validationContext.errors[0]
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>
                          <b-row class="mt-2">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="iccid" class="font-weight-900 mt-2">First ICCID</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <validation-provider
                                  name="iccid"
                                  :rules="{ required: true, regex: /^([0-9]+)$/, min: 18, max: 20 }"
                                  v-slot="validationContext"
                              >
                                <b-form-group id="iccid" class="mb-0">
                                  <b-form-input
                                      id="iccid"
                                      name="iccid"
                                      size="sm"
                                      v-model="selectedProfile.iccid"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="iccid"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback id="iccid">{{
                                      validationContext.errors[0]
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>

                          <b-row class="mt-2">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="profiserverProviderNameleType" class="font-weight-900 mt-2">Service Provider
                                Name</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <validation-provider
                                  name="serverProviderName"
                                  :rules="{ required: true, regex: /^([A-Za-z0-9._ ]+)$/  }"
                                  v-slot="validationContext"
                              >
                                <b-form-group id="serverProviderName" class="mb-0">
                                  <b-form-input
                                      id="serverProviderName"
                                      name="serverProviderName"
                                      size="sm"
                                      v-model="selectedProfile.serviceProviderName"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="serverProviderName"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback id="serverProviderName">{{
                                      validationContext.errors[0]
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>

                          <b-row class="mt-2">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="mccMnc" class="font-weight-900 mt-2">MccMnc</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <validation-provider
                                  name="mccMnc"
                                  :rules="{ required: true, regex: /^([0-9]+)$/, length: 6  }"
                                  v-slot="validationContext"
                              >
                                <b-form-group id="mccMnc" class="mb-0">
                                  <b-form-input
                                      id="mccMnc"
                                      name="mccMnc"
                                      size="sm"
                                      v-model="selectedProfile.mccMnc"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="mccMnc"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback id="mccMnc">{{
                                      validationContext.errors[0]
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>
                          <b-row class="mt-2">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="grid1" class="font-weight-900 mt-2">Gid 1</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <validation-provider
                                  name="gid1"
                                  :rules="{ required: true }"
                                  v-slot="validationContext"
                              >
                                <b-form-group id="gid1" class="mb-0">
                                  <b-form-input
                                      id="gid1"
                                      name="gid1"
                                      size="sm"
                                      v-model="selectedProfile.gid1"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="gid1"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback id="gid1">{{
                                      validationContext.errors[0]
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>
                          <b-row class="mt-2">
                            <b-col md="4" lg="4" class="text-md-left text-lg-left text-center">
                              <label for="gid2" class="font-weight-900 mt-2">Gid 2</label>
                            </b-col>
                            <b-col md="8" lg="8">
                              <validation-provider
                                  name="gid2"
                                  :rules="{ required: true }"
                                  v-slot="validationContext"
                              >
                                <b-form-group id="gid2" class="mb-0">
                                  <b-form-input
                                      id="gid2"
                                      name="gid2"
                                      size="sm"
                                      v-model="selectedProfile.gid2"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="gid2"
                                  >
                                  </b-form-input>
                                  <b-form-invalid-feedback id="gid2">{{
                                      validationContext.errors[0]
                                    }}
                                  </b-form-invalid-feedback>
                                </b-form-group>
                              </validation-provider>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col md="4" lg="3" class="text-center">
                          <base-button
                            type="primary"
                            size="sm"
                            title="Save Profile to Server"
                            nativeType="submit"
                            class="mt-3 mt-md-2 mr-0 w-100">
                            Save Profile
                          </base-button>
                          <br>
                          <base-button class=" mt-3 w-100" size="sm" type="success" title="Publish Carrier Profile"
                                       v-on:click="pushCarrierTemplate(selectedProfile.profileType)"
                          :disabled="!publishReady"
                          >
                            Publish to TruPhone
                          </base-button>
                          <p>&nbsp;</p>
                          <div class="text-left text-black card-background">
                            {{ statusText }}
                          </div>

                        </b-col>
                      </b-row>
                      <b-row class="mt-3">
                        <table class="table eSimVariableTable ml-3 mr-3" id="myTable"
                               v-if="selectedVariables.length > 0">
                          <thead>
                          <th scope="col-2" class="name">
                            <span class="text-white">Name</span>
                          </th>
                          <th scope="col-6" class="ef"><span class="text-white">EF Variables</span></th>
                          <th scope="col-2" class="action"><span class="text-white">Action</span></th>
                          </thead>
                        </table>
                        <b-col md="12" lg="12" v-for="(val, index) in selectedVariables" :key="index">
                          <div class="input-group esim-create-profile mb-1">
                            <b-input-group :prepend="val.name" id="carrier-profile-prepend">
                              <resizable-textarea ref="resize">
                                <b-form-textarea
                                    id="EF_ASEP"
                                    type="text"
                                    rows="1"
                                    ref="textarea"
                                    v-model="val.defaultValue"
                                    :maxlength="val.length"
                                    wrap="soft"
                                ></b-form-textarea>
                              </resizable-textarea>
                              <span class="group-append-button">
													<b-input-group-append is-text>
														<b-form-checkbox
                                value="ascii"
                                class="ascii-preview"
                                unchecked-value="hex"
                                v-on:change="existConvertCode(val.defaultValue, val.name,  $event)">
                            Preview</b-form-checkbox>
													</b-input-group-append>
<!--													<b-input-group-append is-text>-->
<!--														<b-form-checkbox-->
<!--                                v-model="val.sensitive"-->
<!--                                value="true"-->
<!--                                unchecked-value="false"-->
<!--                                disabled-->
<!--                            >Encrypted</b-form-checkbox-->
<!--                            >-->
<!--													</b-input-group-append>-->
												</span>
                            </b-input-group>

                          </div>
                        </b-col>
                        <b-col md="6" lg="6"></b-col>
                      </b-row>
                    </b-form>
                  </validation-observer>
                </b-card-body>
              </template>
            </b-collapse>
          </b-card>
        </template>
      </div>

    </base-header>
  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import coreutils from '../../../common/coreutils';
import ResizableTextarea from '../../../components/ResizableTextarea.vue'
import {ValidationProvider} from "vee-validate";
import initService from "@/common/api-services/init-service";

export default {
  name: "eSimCarrierAdmin",
  components: {RouteBreadCrumb, ResizableTextarea, ValidationProvider},
  data() {
    return {
      defaultProfile: {
        parent: '',
        profileType: '',
        profileTypeId: '',
        profileName: '',
        iccid: '',
        providerName: '',
        mccMnc: '',
        gid1: '',
        gid2: ''
      },
      selectedProfile: {
        parent: '',
        profileType: '',
        profileTypeId: '',
        profileName: '',
        iccid: '',
        providerName: '',
        mccMnc: '',
        gid1: '',
        gid2: ''
      },
      publishReady:false,
      statusText:'',
      profileTypeList: [],
      variables: true,
      defaultVariableData: [],
      variableTemplate: [],
      templateOption: [],
      maxlength: 0,
      profileTypeStatus: false,
      profileTypes: [],
      defaultProfileTypeClick: false,
      profileTypeLoading: true,
      templateVariables: [],
      selectedVariables: [],
      defaultVariables: [],
      existingProfileLoading: false
    };
  },
  mounted() {
    document.title = "eSIM - Carrier Admin";
    this.getProfileTypes();
    this.publishReady=false;

		//don't do anything unless the user has access
		if (this.noAccess) {
			this.$router.push("/restricted").catch(() => {});
		} 

  },
  computed: {
		noAccess() {
			// Determine access based on menu link configuration
			let userRoles = initService.getUserRoles();
			let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

			if (!link) {
				return true;
			} else {
				userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
				return userRoles.length === 0;
			}
		}
	},
  methods: {
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },

    resetForm() {
      this.defaultProfile = {
        parent: null,
        profileName: null,
        iccid: null,
        profileType: null,
        providerName: null,
        mccMnc: null,
        gid1: null,
        gid2: null,
      };
      this.publishReady=false;
      this.$nextTick(() => {
        this.$validator.reset()
      });
    },

    reloadButtonClick() {
      this.defaultProfileTypeClick = false;
      this.getProfileTypes();
    },

    getProfileTypes() {
      this.publishReady=false;
      this.profileTypeLoading = true;
      this.profileTypeList = []
      eSimDashboardService.getProfileTypes().then(res => {
        //console.log('got all profiles: ', res.data)
        if (res && res.data && res.data.profileTypes) {
          this.profileTypes = res.data.profileTypes;
          this.profileTypeList.push({value: "", text: "None"});
          res.data.profileTypes.map(item => {
            this.profileTypeList.push({value: item.profileType, text: item.profileType});
          });
        } else {
          this.$toast.error('No profile types returned from server.');
        }
        this.profileTypeLoading = false
      });
    },

    getExistingProfileType(profileType, status) {
      this.publishReady=false;
      if (status && this.selectedProfile !== profileType) {
        this.existingProfileLoading = true;
        this.defaultVariables = [];
        this.selectedVariables = [];
        this.selectedProfile = profileType;
        eSimDashboardService.getParentTemplate(profileType).then(res => {
          //console.log('got a single profile: ', res.data)
          if (res && res.data && res.data.variables) {
            res.data.variables.map(item => {
              //console.log('item: ', item);
              if (JSON.stringify(item).includes("EF_")) {
                let newItem;
                if (item.defaultValue) {
                  newItem = {...item, defaultValue: item.defaultValue.replace(/\\n/g, "\n")}
                } else {
                  newItem = item
                }
                this.selectedVariables.push(newItem);
                this.defaultVariables.push({...newItem});
              }
            });
            //console.log('existing profile: ',res.data);
            //TODO: why is the parent set to the value of the selected profile???
            //@chad reset parent, profileType in dataset.
            this.selectedProfile = {
              parent: '',
              profileType: res.data.profileType,
              profileTypeId: res.data.profileTypeId,
              profileName: res.data.metadata.profileName,
              iccid: res.data.metadata.iccid,
              serviceProviderName: res.data.metadata.serviceProviderName,
              mccMnc: res.data.metadata.profileOwner.mccMnc,
              gid1: res.data.metadata.profileOwner.gid1,
              gid2: res.data.metadata.profileOwner.gid2,
            }
            this.existingProfileLoading = false;
          } else {
            this.$toast.error('No profile type matching [' + profileType + '] was returned from server.');
          }
        })
      }
    },

    getEFVariables() {
      this.templateVariables = [];
      this.defaultVariableData = [];
      eSimDashboardService.getParentTemplate(this.defaultProfile.parent).then(res => {
        if (res && res.data && res.data.variables) {
          res.data.variables.map(item => {
            if (JSON.stringify(item).includes("EF_")) {
              let newItem;
              if (item.defaultValue) {
                newItem = {...item, defaultValue: item.defaultValue.replace(/\\n/g, "\n")}
              } else {
                newItem = item
              }
              this.templateVariables.push(newItem);
              this.defaultVariableData.push({...newItem});
            }
          });

          //Also set the metadata
          this.defaultProfile = {
            parent: '',
            profileType: res.data.profileType,
            profileTypeId: '',
            profileName: res.data.metadata.profileName,
            iccid: res.data.metadata.iccid,
            serviceProviderName: res.data.metadata.serviceProviderName,
            mccMnc: res.data.metadata.profileOwner.mccMnc,
            gid1: res.data.metadata.profileOwner.gid1,
            gid2: res.data.metadata.profileOwner.gid2,
          }

        }
      })
    },

    getExistingEFVariable() {
      this.selectedVariables = [];
      this.defaultVariables = [];
      eSimDashboardService.getParentTemplate(this.defaultProfile.parent).then(res => {
        if (res && res.data && res.data.variables) {
          res.data.variables.map(item => {
            if (JSON.stringify(item).includes("EF_")) {
              let newItem;
              if (item.defaultValue) {
                newItem = {...item, defaultValue: item.defaultValue.replace(/\\n/g, "\n")}
              } else {
                newItem = item
              }
              this.selectedVariables.push(newItem);
              this.defaultVariables.push({...newItem});
            }
          });

          // //Also set the metadata
          // this.selectedProfile = {
          //   parent: '',
          //   profileType: res.data.profileType,
          //   //profileTypeId: res.data.profileTypeId,  //don't change this variable
          //   profileName: res.data.metadata.profileName,
          //   iccid: res.data.metadata.iccid,
          //   serviceProviderName: res.data.metadata.serviceProviderName,
          //   mccMnc: res.data.metadata.profileOwner.mccMnc,
          //   gid1: res.data.metadata.profileOwner.gid1,
          //   gid2: res.data.metadata.profileOwner.gid2,
          // }

        }
      })
    },

    getMaxLength() {
      const lengths = this.defaultVariableData.map(a => a.name.length);
      this.maxlength = lengths.reduce((a, b) => {
        return Math.max(a, b)
      });
    },

    convertCode(value, name, val) {
      if (val === 'ascii') {
        this.convertHex2Ascii(value, name)
      } else {
        this.revertCode(name)
      }
    },

    convertHex2Ascii(value, name) {
      if (value) {
        let code = coreutils.hex2ascii(value);
        this.templateVariables.map(item => {
          if (item.name === name) {
            item.defaultValue = code
          }
        });
      }
    },

    revertCode(name) {
      this.templateVariables.map(item => {
        if (item.name === name) {
          this.defaultVariableData.map((it) => {
            if (it.name === name) {
              item.defaultValue = it.defaultValue
            }
          })
        }
      })
    },

    existConvertCode(value, name, val) {
      if (val === 'ascii') {
        this.existConvertHex2Ascii(value, name)
      } else {
        this.existRevertCode(name)
      }
    },

    existConvertHex2Ascii(value, name) {
      if (value) {
        let code = coreutils.hex2ascii(value);
        this.selectedVariables.map(item => {
          if (item.name === name) {
            item.defaultValue = code
          }
        });
      }
    },

    existRevertCode(name) {
      this.selectedVariables.map(item => {
        if (item.name === name) {
          this.defaultVariables.map((it) => {
            if (it.name === name) {
              item.defaultValue = it.defaultValue
            }
          })
        }
      })
    },

    saveNewCarrier() {
      let request = {
        profileType: this.defaultProfile.profileType,
        profileTypeId: this.defaultProfile.profileTypeId,
        variables: this.templateVariables,
        metadata: {
          iccid: this.defaultProfile.iccid,
          serviceProviderName: this.defaultProfile.serviceProviderName,
          profileName: this.defaultProfile.profileName,
          profileOwner: {
            mccMnc: this.defaultProfile.mccMnc,
            gid1: this.defaultProfile.gid1,
            gid2: this.defaultProfile.gid2
          }
        }
      }
      eSimDashboardService.saveCarrierTemplate(request).then(res => {
        if (res && res.data.header && res.data.header.functionExecutionStatus.status === 'Success') {
          this.$toast.success(res.data.header.functionExecutionStatus.statusCodeData.message);
          this.statusText=request.profileType+':'+res.data.header.functionExecutionStatus.statusCodeData.message;
          this.publishReady=true;
        } else {
          this.publishReady=false;
          this.$toast.error(res.data.header.functionExecutionStatus.statusCodeData.message);
          this.statusText=request.profileType+':'+res.data.header.functionExecutionStatus.statusCodeData.message;
        }
      }).catch(e => {
        this.publishReady=false;
        this.$toast.error(JSON.stringify(e));
        this.statusText=request.profileType+':'+JSON.stringify(e);
      });

    },

    saveCarrierTemplate() {
      let request = {
        profileType: this.selectedProfile.profileType,
        profileTypeId: this.selectedProfile.profileTypeId,
        variables: this.selectedVariables,
        metadata: {
          iccid: this.selectedProfile.iccid,
          serviceProviderName: this.selectedProfile.serviceProviderName,
          profileName: this.selectedProfile.profileName,
          profileOwner: {
            mccMnc: this.selectedProfile.mccMnc,
            gid1: this.selectedProfile.gid1,
            gid2: this.selectedProfile.gid2
          }
        }
      }
      eSimDashboardService.saveCarrierTemplate(request).then(res => {
        if (res && res.data.header && res.data.header.functionExecutionStatus.status === 'Success') {
          this.$toast.success(res.data.header.functionExecutionStatus.statusCodeData.message);
          this.statusText=request.profileType+':'+res.data.header.functionExecutionStatus.statusCodeData.message;
          this.publishReady=true;
        } else {
          this.publishReady=false;
          this.$toast.error(res.data.header.functionExecutionStatus.statusCodeData.message);
          this.statusText=request.profileType+':'+res.data.header.functionExecutionStatus.statusCodeData.message;
        }
      }).catch(e => {
        this.publishReady=false;
        this.$toast.error(JSON.stringify(e));
        this.statusText=request.profileType+':'+JSON.stringify(e);
      });
    },

    pushCarrierTemplate(profileType) {
      eSimDashboardService.pushCarrierTemplate(profileType).then(res => {
        if (res && res.data.header && res.data.header.functionExecutionStatus.status === 'Executed-Success') {
          let msg = profileType+': Successfully pushed carrier template.';
          this.$toast.success(msg);
          this.statusText=msg;
        } else {
          let msg = profileType+': Failed to push carrier template.';
          if (res.data.header.functionExecutionStatus.statusCodeData.message)
            msg += res.data.header.functionExecutionStatus.statusCodeData.message;
          this.$toast.error(msg);
          this.statusText=msg;
        }
      }).catch(e => {
        this.statusText=profileType+': Failed to push template. '+JSON.stringify(e);
        this.$toast.error(profileType+': Failed to push template. '+JSON.stringify(e));
      });
      this.publishReady=false;
    },

  }
};
</script>
